import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from 'context/AuthContext';
import { Button, Input } from '../ui';

export default function RegisterPage() {
  const { register, error, loading } = useAuth();
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [fieldErr, setFieldErr] = useState('');
  const [sent, setSent] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setFieldErr('');
    if (!name || !email || !password) { setFieldErr('Todos los campos son requeridos'); return; }
    if (password.length < 6) { setFieldErr('La contraseña debe tener al menos 6 caracteres'); return; }
    if (password !== confirm) { setFieldErr('Las contraseñas no coinciden'); return; }
    const res = await register(name, email, password);
    if (res.success) setSent(true);
  };

  return (
    <div style={{
      minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
      background: 'var(--bg-base)', padding: '16px',
      backgroundImage: 'radial-gradient(ellipse 80% 60% at 50% -10%, #1a0a2e 0%, transparent 70%), radial-gradient(ellipse 40% 40% at 80% 80%, #0a1628 0%, transparent 60%)',
    }}>
      <div className="animate-scaleIn" style={{ width: '100%', maxWidth: '420px' }}>
        <div style={{ textAlign: 'center', marginBottom: '40px' }}>
          <div style={{ width: '80px', height: '80px', margin: '0 auto 16px' }}>
            <img src="/thitan-logo.png" alt="TX-Flow AI" style={{ width: '80px', height: '80px', objectFit: 'contain' }} />
          </div>
          <h1 style={{ fontFamily: 'var(--font-display)', fontSize: '28px', fontWeight: '800', background: 'linear-gradient(90deg, #a855f7, #3b82f6)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>
            TX-Flow AI
          </h1>
          <p style={{ color: 'var(--text-muted)', fontSize: '14px', marginTop: '6px' }}>Crea tu cuenta gratis</p>
        </div>

        <div style={{ background: 'var(--bg-card)', border: '1px solid var(--border)', borderRadius: 'var(--radius-xl)', padding: '32px', boxShadow: 'var(--shadow-lg)' }}>
          {sent ? (
            <div style={{ textAlign: 'center', padding: '12px 0' }}>
              <div style={{ fontSize: '48px', marginBottom: '12px' }}>📧</div>
              <h2 style={{ fontFamily: 'var(--font-display)', fontSize: '18px', fontWeight: '700', marginBottom: '8px' }}>Revisa tu correo</h2>
              <p style={{ color: 'var(--text-muted)', fontSize: '14px', lineHeight: 1.6 }}>
                Te enviamos un enlace de confirmación a <strong>{email}</strong>. Ábrelo para activar tu cuenta gratis.
              </p>
              <Link to="/login" style={{ display: 'inline-block', marginTop: '20px', color: 'var(--accent-primary)', fontWeight: '600', fontSize: '13px', textDecoration: 'none' }}>← Volver al login</Link>
            </div>
          ) : (
            <>
              <h2 style={{ fontFamily: 'var(--font-display)', fontSize: '20px', fontWeight: '700', marginBottom: '24px' }}>Crear cuenta</h2>
              <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
                <Input label="Nombre" type="text" value={name} onChange={setName} placeholder="Tu nombre" icon="👤" required />
                <Input label="Email" type="email" value={email} onChange={setEmail} placeholder="tu@email.com" icon="✉" required />
                <Input label="Contraseña" type="password" value={password} onChange={setPassword} placeholder="••••••••" icon="🔒" required />
                <Input label="Confirmar contraseña" type="password" value={confirm} onChange={setConfirm} placeholder="••••••••" icon="🔒" required />

                {(fieldErr || error) && (
                  <div style={{ background: '#ef444415', border: '1px solid #ef444430', borderRadius: 'var(--radius-md)', padding: '10px 14px', fontSize: '13px', color: '#ef4444', display: 'flex', alignItems: 'center', gap: '8px' }}>
                    ⚠️ {fieldErr || error}
                  </div>
                )}

                <Button type="submit" loading={loading} size="lg" style={{ marginTop: '8px', width: '100%' }}>
                  {loading ? 'Creando cuenta...' : 'Crear cuenta gratis'}
                </Button>
              </form>

              <p style={{ textAlign: 'center', fontSize: '13px', color: 'var(--text-muted)', marginTop: '20px' }}>
                ¿Ya tienes cuenta? <Link to="/login" style={{ color: 'var(--accent-primary)', fontWeight: '600', textDecoration: 'none' }}>Inicia sesión</Link>
              </p>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
